import axios from "axios";

const baseHeaders = {
  "Content-Type": "application/json",
};
const baseUrl = process.env.REACT_APP_API_ENDPOINT;

export const getAxiosAPIInstance = () => {
  const API = axios.create({
    baseURL: baseUrl,
    headers: baseHeaders,
    timeout: 50000,
  });

  API.interceptors.request.use((req) => {
    const rawToken = localStorage.getItem("token");
    const token = rawToken ? JSON.parse(rawToken) : null;
  
    if (token && !req.headers.Authorization) {
      req.headers.Authorization = `Bearer ${token}`;
    }
  
    return req;
  });

  return API;
};
